(ns journal-app-client.utils.hooks
  (:require [journal-app-client.utils.interop :as interop]
            [journal-app-client.utils.react :as react]
            [re-frame.core :as rf]))

(defn use-on-before-unload [db-updates db-updates-ref original-map patch-fn]
  (react/use-effect
    (fn mount []
      (set! (.-current db-updates-ref) db-updates)
      (if (empty? db-updates)
        (when (fn? (.-onbeforeunload (.-body js/document)))
          (set! (.-onbeforeunload (.-body js/document)) nil))
        (when-not (fn? (.-onbeforeunload (.-body js/document)))
          (set! (.-onbeforeunload (.-body js/document))
                (fn on-before-unload [event]
                  (.preventDefault event)
                  "Are you sure you want to quit?"))))
      (fn dismount []))
    #js [db-updates])
  (react/use-effect
    (fn mount []
      (fn dismount []
        (when-not (false? (.-current db-updates-ref))
          (let [db-updates (.-current db-updates-ref)
                new-map (reduce-kv
                          (fn [m k v] (assoc-in m k v))
                          original-map
                          db-updates)]
            (when-not (= new-map original-map)
              (rf/dispatch
                [:open-modal :confirm
                 {:title         "Save changes?"
                  :confirm-text  "Save"
                  :confirm-props {:class       "is-success"
                                  :loading-key :patch!
                                  :on-click    (fn [])}
                  :children      (into
                                   [:div
                                    [:p.subtitle
                                     [:span "You have unsaved changes for "]
                                     [:span
                                      {:style {:text-decoration "underline"
                                               :color           "var(--warning)"}}
                                      (get-in new-map [:information :name])]
                                     [:span " node."]]]
                                   (map
                                     (fn [[path v]]
                                       (let [old-value (get-in original-map path)]
                                         (when-not (= v old-value)
                                           [:div
                                            {:key (str path)}
                                            [:p.help (str path)]
                                            [:div
                                             {:style {:display "flex"}}
                                             [:p.help (str (or old-value "None"))]
                                             [:span.icon [:i.fas.fa-arrow-right]]
                                             [:p.help (str v)]]])))
                                     db-updates))}]))))))
    #js [true]))

(defn use-position-in-view [ref id]
  (let [[position set-position] (react/use-state 0)
        window-width @(rf/subscribe [:window-size :width])
        set-timeout-id (str "use-position-in-view" id)]
    (react/use-effect
      (fn []
        (set-position 0)
        (interop/set-timeout
          {:id set-timeout-id
           :callback (fn []
                       (let [bounding-box (.getBoundingClientRect (.-current ref))
                             position (cond (< (.-x bounding-box) 0)
                                            (- (.-x bounding-box) 5)
                                            (> (+ (.-width bounding-box) (.-x bounding-box)) window-width)
                                            (+ (- (+ (.-width bounding-box) (.-x bounding-box)) window-width) 5)
                                            :else 0)]
                         (set-position position)))
           :ms 300})
        (fn [] (interop/set-timeout {:id set-timeout-id :action :clear})))
      #js [window-width])
    position))